// extracted by mini-css-extract-plugin
export var active = "style-module--active--d164f";
export var image = "style-module--image--10bd9";
export var slide = "style-module--slide--7bdc4";
export var slideshowContainer = "style-module--slideshowContainer--8a4c0";